import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { NewSpaceGroupModalComponent } from "./NewSpaceGroupModalComponent";
import { NewSpaceGroupModalUIKitComponent } from "./NewSpaceGroupModalUIKitComponent";

export const useNewSpaceGroupModal = createCompassModalSwitcher(
  NewSpaceGroupModalComponent,
  NewSpaceGroupModalUIKitComponent,
);
